import type {
  Condicao,
  FiltrosDisponiveis,
  Ordenacao,
  ProdutoDetalhe,
  ProdutoResumo,
  RespostaPaginada,
} from '@peniel/shared'

import { apiFetch } from './client.js'

export interface FiltrosVitrine {
  busca?: string
  condicao?: Condicao
  categoria?: string
  marca?: string
  aro?: string
  precoMin?: number
  precoMax?: number
  disponibilidade?: 'todas' | 'disponiveis'
  destaque?: boolean
  ordenar?: Ordenacao
  pagina?: number
  porPagina?: number
}

/** Descarta undefined/vazio para a URL não ficar com `&marca=`. */
function montarQuery(filtros: FiltrosVitrine): string {
  const params = new URLSearchParams()
  for (const [chave, valor] of Object.entries(filtros)) {
    if (valor === undefined || valor === null || valor === '') continue
    params.set(chave, String(valor))
  }
  const query = params.toString()
  return query ? `?${query}` : ''
}

export function listarProdutos(
  filtros: FiltrosVitrine = {},
): Promise<RespostaPaginada<ProdutoResumo>> {
  return apiFetch(`/produtos${montarQuery(filtros)}`)
}

export function obterProdutoPorSlug(slug: string): Promise<ProdutoDetalhe> {
  return apiFetch(`/produtos/${encodeURIComponent(slug)}`)
}

export function obterFiltrosDisponiveis(): Promise<FiltrosDisponiveis> {
  return apiFetch('/filtros')
}
